module.exports = __webpack_public_path__ + "static/media/empty-groups.bf406bd2.svg";